import React from 'react';

const BundleContext = React.createContext({ getCardIdReferenceCount : () => {}, bundleList : [] })

function BundleProvider({ children }) {
    const [bundleList, setBundleList] = React.useState([]);
    const [cardIdReferenceList, setCardIdReferenceList] = React.useState({})

    React.useEffect(() => {
        const refList = {};
        for (let b of bundleList) {
            for (let c of b.cards || []) {
                if (c.cardId) {
                    if (refList[c.cardId])
                        refList[c.cardId].push(b.id);
                    else
                        refList[c.cardId] = [b.id];
                }
            }
        }
        console.log({bundleList, refList});
        setCardIdReferenceList(refList);

    }, [bundleList])

    function getCardIdReferenceCount(cardId) {
        console.log({cardIdReferenceList, cardId})
        return cardIdReferenceList[cardId]?.length || 0;
    }

    return (
    <BundleContext.Provider value={{bundleList, getCardIdReferenceCount, setBundleList}} >
            {children}
    </BundleContext.Provider>        
    )

}

export  { BundleContext, BundleProvider };


/*

*/